import React, { useState, useContext, useEffect, createRef, useRef } from 'react';
import { Form, Button, Input, Avatar, Divider, Modal, Spin, Icon, notification, Dropdown, Menu, message } from 'antd';
import GlobalStateContext from '../../../../context'
import Webservice from '../../../../classes/WebService';

import { _notification, ucFirst } from '../../../../utils';

import DestinationWebservice from '../../../../classes/DestinationWebservice';

import defaultIcon from "../../../../assets/images/rec.png"
import AddDestination from './AddDestination';
import StreamWebService from '../../../../classes/StreamWebService';
import plusIcon from '../../../../assets/images/plus.png'
import { Link } from '@material-ui/core';
import ConfirmDestinationDelete from '../../../../components/DestinationCard';


const ConnectedDestMenu = (props) => {

  let [safeUrl, setSafeUrl] = useState("");


  useEffect(() => {

    let _safeUrl, id;
    if (props.playbackUrl) {
      if (props.platform == "twitch") {
        id = props.label
      } else {
        id = props.platformResourceId
      }

      _safeUrl = props.playbackUrl
        .replace("{video_id}", id)
        .replace("{channel_id}", id)

      console.log("safeurl: ", props.playbackUrl, _safeUrl, "resourceId:", props.platformResourceId)
      setSafeUrl(_safeUrl);

    }

  }, [props.isActive, props.platformResourceId])


  return <>
    <div className='rounded-xl bg-white shadow-2xl border border-gray-200 overflow-hidden min-w-[200px]'>

      {/* Header */}
      <div className='bg-gradient-to-r from-blue-600 to-blue-700 py-2.5 px-4 text-white'>
        <div className="font-semibold text-sm truncate">{props.label}</div>
      </div>

      {/* Menu Items */}
      <div className='py-1'>
        {/* Enable/Disable */}
        <div
          className='cursor-pointer hover:bg-blue-50 transition-colors duration-150 px-4 py-2.5 flex items-center gap-3 group'
          onClick={props.onClick}
        >
          <div className={`w-2 h-2 rounded-full ${props.isActive ? 'bg-green-500' : 'bg-gray-400'}`}></div>
          <span className="text-sm font-medium text-gray-700 group-hover:text-blue-600">
            {props.isActive ? 'Disable' : 'Enable'}
          </span>
        </div>

        {/* View on Platform */}
        {(props.isActive && !!props?.platform && props?.platform != 'custom') && (
          <a
            href={safeUrl}
            target='_blank'
            rel="noopener noreferrer"
            className='cursor-pointer hover:bg-blue-50 transition-colors duration-150 px-4 py-2.5 flex items-center gap-3 group no-underline'
          >
            <Icon type="eye" className="text-gray-400 group-hover:text-blue-600 transition-colors" />
            <span className="text-sm font-medium text-gray-700 group-hover:text-blue-600">
              View on {ucFirst(props?.platform)}
            </span>
            <Icon type="export" className="text-gray-400 ml-auto text-xs" />
          </a>
        )}

        {/* Divider */}
        <div className="border-t border-gray-100 my-1"></div>

        {/* Delete */}
        <div
          className='cursor-pointer hover:bg-red-50 transition-colors duration-150 px-4 py-2.5 flex items-center gap-3 group'
          onClick={props.onDelete}
        >
          <Icon type="delete" className="text-gray-400 group-hover:text-red-600 transition-colors" />
          <span className="text-sm font-medium text-gray-700 group-hover:text-red-600">
            Delete
          </span>
        </div>
      </div>
    </div>

  </>
}

let closeActiveDropdown = null;

export function ConnectDestinationItem(props) {
  const active = (props.active ? ' active' : '')
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const closeTimer = useRef(null);

  const openDropdown = () => {
    if (closeActiveDropdown) closeActiveDropdown();
    closeActiveDropdown = () => setDropdownOpen(false);
    if (closeTimer.current) clearTimeout(closeTimer.current);
    setDropdownOpen(true);
  };

  const scheduleClose = () => {
    closeTimer.current = setTimeout(() => {
      setDropdownOpen(false);
      closeActiveDropdown = null;
    }, 80);
  };

  const handleClick = (e) => {
    console.log('Item clicked, mobileExpanded:', props.mobileExpanded, 'width:', window.innerWidth);

    // On mobile, if not expanded, expand the container first
    if (window.innerWidth <= 768 && !props.mobileExpanded) {
      console.log('Expanding container');
      if (props.onExpand) {
        props.onExpand();
      }
      e.stopPropagation();
      return;
    }

    // Desktop or already expanded - proceed with toggle
    if (props.onClick && props.id) {
      props.onClick(props.id);
    }
  };

  const item = (<div key={props.id} className={"added-channel"}
    onClick={handleClick}
    onMouseEnter={openDropdown}
    onMouseLeave={scheduleClose}>

    {props.isLoading ? <Icon type="loading" style={{ fontSize: 50 }} spin /> : <>
      <div className='flex' style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center"
      }}>
        {props.buttonContent ||
          <Avatar className={"channel " + (active)}
            size={40}
            key={props.id}
            src={props.channelImage || defaultIcon}
            alt={props.id} />}

        {props.platformImage && <Avatar
          className={'platform ' + active}
          style={{ "position": "relative", "background": "white", "margin": "-20px auto 0px auto" }}
          size={22}
          src={props.platformImage}
          alt={props.id} />}


      </div>

    </>
    }
  </div>)


  // Only show dropdown on desktop or when mobile is expanded
  const shouldShowDropdown = props.id && (props.mobileExpanded || window.innerWidth > 768);

  return shouldShowDropdown ?
    <Dropdown
      visible={dropdownOpen}
      transitionName=""
      overlay={
        <div onMouseEnter={openDropdown} onMouseLeave={scheduleClose}>
          <ConnectedDestMenu label={props.label} token={props.token}
            platformImage={props.platformImage}
            platform={props.platform} isActive={props.active}
            playbackUrl={props.playbackUrl}
            platformResourceId={props.platformResourceId}
            onDelete={props.onDelete}
            onClick={() => props.onClick && props.onClick(props.id)} />
        </div>
      }>
      {item}

    </Dropdown> :
    item

}


const ConnectDestinations = function (props) {
  const [state] = useContext(GlobalStateContext);
  const { features_accessible, user, io } = state;
  const { getFieldDecorator, setFieldsValue } = props.form;
  const [destinations, setDestinations] = useState([]);
  const [token, setToken] = useState("");
  const [isLoading, setLoading] = useState(false);
  const [activeDestinations, setActiveDestinations] = useState(props.stream.destinations || []);
  const [showDestinationForm, setShowDestinationForm] = useState(false);
  // const [allow, setAllow] = useState(false);
  const formRef = createRef();
  const [systemDests, setSystemDests] = useState({});
  let [confirmDelete, setConfirmDelete] = useState(false);
  const [mobileExpanded, setMobileExpanded] = useState(false);
  const destinationsRef = useRef(null);



  const systemDestsToDict = () => {
    const dict = {}
    for (let dest of state.stream_destinations) {
      dict[dest.id] = dest;
    }
    setSystemDests(dict);
  }


  const fetchDestinations = async () => {
    try {
      const webservice = new DestinationWebservice();
      webservice.fetchDestinations()
        .then(res => res.data.entries)
        .then(dest => setDestinations(dest || []));
    } catch (error) {
      _notification.error("Failed to fetch destinations");
    }
  }

  const cleanUp = () => {
    io.removeAllListeners(`platformtoken_${props.provider}_${props.key}`)
    setToken("");
  }

  useEffect(() => {
    systemDestsToDict();
    console.log("this")
    fetchDestinations();
    if (props.stream.destinations) {
      setActiveDestinations(props.stream.destinations.filter(el => el != null))
    }

    io.on(`${props.stream.token}_done_publish`, dests => { setActiveDestinations([dests]) })
    io.on(`${props.stream.token}_terminated`, fetchDestinations)
    return cleanUp;
  }, []);

  // Handle click outside to collapse on mobile
  useEffect(() => {
    const handleClickOutside = (event) => {
      console.log('Click detected, mobileExpanded:', mobileExpanded, 'width:', window.innerWidth);

      if (window.innerWidth <= 768 && mobileExpanded) {
        if (destinationsRef.current) {
          const isClickInside = destinationsRef.current.contains(event.target);
          console.log('Is click inside destinations?', isClickInside);

          if (!isClickInside) {
            console.log('Clicked outside, collapsing');
            setMobileExpanded(false);
          }
        }
      }
    };

    // Add listeners with a slight delay to ensure state is updated
    if (mobileExpanded) {
      setTimeout(() => {
        document.addEventListener('mousedown', handleClickOutside, true);
        document.addEventListener('touchstart', handleClickOutside, true);
      }, 100);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside, true);
      document.removeEventListener('touchstart', handleClickOutside, true);
    };
  }, [mobileExpanded]);



  const onClick = async (destId) => {
    // e.preventDefault();
    console.log(activeDestinations)
    const isUnlimited = features_accessible?.max_destinations == -1
    const alreadyActive = activeDestinations.findIndex(dest => dest?.id == destId) != -1
    const exhusted = activeDestinations.length >= features_accessible?.max_destinations;
    console.log(isUnlimited, alreadyActive, exhusted)
    if (!isUnlimited && !alreadyActive && exhusted) {
      _notification.info(`You can only activate ${features_accessible.max_destinations} destinations per stream`)
      return
    }
    setLoading(destId);
    let service = new StreamWebService();


    await service.toggleDestination(props.stream.id, destId)

      .then(resp => {
        if (resp.status === 200) {

          setActiveDestinations(resp.data.destinations || []);

        } else {
          console.log("[x] respt", resp)
          if (`${resp.status}`.indexOf(4) == 0) { //4XX errorS
            Modal.info({

              content: resp.message,
              okText: resp.data.action ? "Reconnect" : "Okay",
              onOk() {

                resp.data?.action && window.open(resp.data?.action);
                console.log("listening to ", `platformtoken_${resp.data?.provider}_${props.stream?.id}`)
                io.on(`platformtoken_${resp.data?.provider}_${props.stream?.id}`, payload => {
                  console.log("reconnected payload", payload)
                  setActiveDestinations([...activeDestinations, payload])
                  Modal.success({ content: "Destinated reconnnected successfully." })
                });

              }


            })
          } else {

            _notification.error(resp.message);
          }
        }
      })
      .catch(err => {
        _notification.error(`Operation failed. ${err.message}`);
      });
    setLoading(false);

  }


  const deleteDestination = () => {

    const wbs = new DestinationWebservice();
    console.log(confirmDelete)
    wbs.deleteDestination(confirmDelete?.id)
      .then(_ => {
        fetchDestinations().then(_ => {

          message.success(`Destination deleted`);
          setConfirmDelete(false);
        })
      })
      .catch(_ => {
        message.success(`Failed to delete destinaton`);
      })

  }


  const sst = { maxWidth: "300px" }

  activeDestinations.filter(el => el != null)

  return (
    <>


      <div ref={destinationsRef} className={`m-auto added-channels flex justify-center ${mobileExpanded ? 'mobile-expanded' : ''}`}>

        {

          destinations.filter(des => !!des).map((dest) => {

            const pltf = systemDests[dest['platform']];
            const platformImage = pltf ? pltf['logo'] : "";
            const activeIndex = activeDestinations.findIndex(el => el?.id == dest.id)
            const activeConnectionObject = activeDestinations[activeIndex]

            return (
              <ConnectDestinationItem
                key={dest.id}
                label={dest.label}
                isLoading={isLoading == dest.id}
                active={activeIndex > -1}
                onClick={onClick}
                onDelete={_ => setConfirmDelete({ ...pltf, platformImage, ...dest })}
                id={dest.id}
                platform={pltf?.provider}
                channelImage={dest.image_url}
                token={activeConnectionObject?.token}
                platformImage={platformImage}
                platformResourceId={activeConnectionObject?.resource_id}
                playbackUrl={pltf?.playback_url}
                mobileExpanded={mobileExpanded}
                onExpand={() => setMobileExpanded(true)} />
            )
          })

        }


        <div className='added-channel'>

          <AddDestination callback={fetchDestinations} content={
            destinations.length > 0 ? <ConnectDestinationItem channelImage={plusIcon} platformImage={""} /> :
              <ConnectDestinationItem channelImage={plusIcon} platformImage={""} buttonContent={props.addDestinationContent} />
          } />
        </div>



        {!!confirmDelete && <ConfirmDestinationDelete
          platform={confirmDelete?.provider}
          channel={confirmDelete?.label}
          onConfirm={deleteDestination}
          OnCancel={_ => setConfirmDelete(false)} platformImage={confirmDelete?.platformImage}
          channelImage={confirmDelete?.image_url} />
        }

      </div>
    </>
  )
}

export default Form.create()(ConnectDestinations);